/**
 * @module sendError
 * @alias Fiverr._logErrorToServer
 * @since 1.7.0
 */

import { alias } from '../../__alias';

/**
 * Report error to server. Aliases Fiverr._logErrorToServer
 * @param  {string} file
 * @param  {string} method
 * @param  {string} error
 * no return value
 *
 * @example
 * sendError('my_file.js', 'my_method_name', `expected argument to be string got ${typeof arguments[0]}`)
 */
export const sendError = alias('_logErrorToServer');
